import { render, staticRenderFns } from "./trainer-course-completion.vue?vue&type=template&id=250953a4"
import script from "./trainer-course-completion.vue?vue&type=script&lang=js"
export * from "./trainer-course-completion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports